import { createSlice } from "@reduxjs/toolkit";

const adminPermissionSlice = createSlice({
    name: "adminPermission",
    initialState: {
        isLoading: false,
        adminRoleList: []
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setAdminRoleList(state, action) {
            state.adminRoleList = action.payload;
        }
    }
});

export const {
    setIsLoading,
    setAdminRoleList
} = adminPermissionSlice.actions;

export default adminPermissionSlice.reducer;